import { render, staticRenderFns } from "./SkillCorridor.vue?vue&type=template&id=d8e9319e&"
import script from "./SkillCorridor.vue?vue&type=script&lang=ts&"
export * from "./SkillCorridor.vue?vue&type=script&lang=ts&"
import style0 from "./SkillCorridor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports